export const UNLIMITED_TRESHOLD = 100000
export const UNLIMITED_VARIANTS_TRESHOLD = 400
export const UNLIMITED_CRM_PIPELINE = 100
